export const RULE = {
    FLOAT_NUMBER: /^([0-9０-９]+([.][0-9０-９]*)?|[.][0-9０-９]+)$/,
    NUMBER: /^[0-9０-９]*$/,
    EMAIL: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
};
